import { render, staticRenderFns } from "./QuestionSurvey.vue?vue&type=template&id=581103b2&scoped=true"
import script from "./QuestionSurvey.vue?vue&type=script&lang=js"
export * from "./QuestionSurvey.vue?vue&type=script&lang=js"
import style0 from "./QuestionSurvey.vue?vue&type=style&index=0&id=581103b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581103b2",
  null
  
)

export default component.exports